/**
 * Admin gallery list/detail shape:
 * images: [{ id, gallery_id, image_url, image_key, sort_order, created_at, ... }]
 */
function safeImgSrc(url) {
  if (!url || typeof url !== 'string') return url;
  const t = url.trim();
  if (!t) return t;
  // S3 paths may include spaces (e.g. "…/images (1).jpeg"); encode for valid <img src>.
  try {
    return /\s/.test(t) ? encodeURI(t) : t;
  } catch {
    return t;
  }
}

/**
 * Normalize gallery `images` from list/detail API (strings or row objects).
 * @returns {{ id: string | null; url: string; key: string }[]}
 */
export function parseGalleryImageEntries(gallery) {
  const raw =
    gallery?.images ??
    gallery?.image_urls ??
    gallery?.photos ??
    gallery?.imageUrls ??
    gallery?.gallery_images ??
    gallery?.galleryImages;
  if (!Array.isArray(raw)) return [];
  return raw
    .map((entry, idx) => {
      if (typeof entry === 'string') {
        const u = safeImgSrc(entry);
        if (!u) return null;
        return {
          id: null,
          url: u,
          key: `s-${idx}`,
          _order: idx,
          _t: 0,
        };
      }
      const id = entry?.id ?? entry?._id ?? entry?.image_id ?? entry?.imageId;
      const rawUrl =
        entry?.image_url ??
        entry?.url ??
        entry?.imageUrl ??
        entry?.imageURL ??
        entry?.src ??
        entry?.path ??
        entry?.href ??
        entry?.s3_url ??
        entry?.file_url ??
        entry?.public_url ??
        '';
      const u = typeof rawUrl === 'string' ? safeImgSrc(rawUrl) : '';
      if (!u) return null;
      const order = typeof entry?.sort_order === 'number' && !Number.isNaN(entry.sort_order) ? entry.sort_order : idx;
      const t = entry?.created_at ? new Date(entry.created_at).getTime() : 0;
      return {
        id: id != null && id !== '' ? String(id) : null,
        url: u,
        key: id != null && id !== '' ? String(id) : `i-${idx}`,
        _order: order,
        _t: Number.isNaN(t) ? 0 : t,
      };
    })
    .filter(Boolean)
    .sort((a, b) => a._order - b._order || a._t - b._t)
    .map(({ _order, _t, ...rest }) => rest);
}

export function galleryId(item) {
  return item?.id ?? item?._id;
}

export function galleryImageUrls(item) {
  return parseGalleryImageEntries(item).map((x) => x.url);
}

export function galleryImageCount(item) {
  const n = item?.image_count ?? item?.images_count;
  if (typeof n === 'number' && !Number.isNaN(n)) return n;
  return parseGalleryImageEntries(item).length;
}

/** First image URL for cards / previews (empty string if none). */
export function galleryCoverUrl(gallery) {
  const entries = parseGalleryImageEntries(gallery);
  return entries[0]?.url ?? '';
}

export function publicGalleryPath(id) {
  if (id == null || id === '') return '/gallery';
  return `/gallery/${encodeURIComponent(String(id))}`;
}
